import { defineStore } from 'pinia'
import { fetchPageMeta } from '@/api/lsa/pageMeta'

const STATE = () => ({
  leadOutcomes: []
})

export const useLsaCommonStore = defineStore('lsaCommon', {
  state: () => ({ ...STATE(), loaded: false }),
  actions: {
    initialize(data) {
      Object.keys(STATE()).forEach((key) => {
        if (data[key] !== undefined) this[key] = data[key]
      })
      this.loaded = true
    },
    async ensurePageMeta() {
      if (this.loaded) return

      const res = await fetchPageMeta()
      this.initialize(res.data)
    }
  }
})
